export default __webpack_public_path__ + "static/media/62-min.9f79e356.png";